import { ConexionCompleta } from "@victorequena22/conneccion";

class FacturaConexion extends ConexionCompleta {
    clase = 'Factura';
    persistencia = 1000;
}
export default function conFactura() {
    return new FacturaConexion();
}